const FocusManager = {
    trappedFocusEvent: null,
    $focusableEls: [],
    focusIndex: 0,

    /**
     * Contraint le focus à l'intérieur d'éléments
     * 
     * @param {HTMLElement[]} $elements Éléments dans lesquels contraindre le focus
     */
    trapFocus($elements) {
        this.untrapFocus();

        this.$focusableEls = Array.from($elements).sort(($el, $prevEl) => {
            const prevIndex = parseInt($prevEl.dataset && $prevEl.dataset.focusIndex ? $prevEl.dataset.focusIndex : 100);
            const elIndex = parseInt($el.dataset && $el.dataset.focusIndex ? $el.dataset.focusIndex : prevIndex + 1);

            return elIndex > prevIndex ? 1 : -1;
        });

        this.focusIndex = this.$focusableEls.indexOf(document.activeElement);

        this.trappedFocusEvent = evt => {
            if (evt.key !== 'Tab') {
                return;
            }
        
            if (evt.shiftKey) { // shift + tab
                evt.preventDefault();

                this.focusIndex--;

                if (this.focusIndex < 0) {
                    this.focusIndex = this.$focusableEls.length - 1;
                }
            } else { // tab
                evt.preventDefault();

                this.focusIndex++;

                if (this.focusIndex > this.$focusableEls.length - 1) {
                    this.focusIndex = 0;
                }
            }

            this.$focusableEls[this.focusIndex].focus();
        };

        document.addEventListener('keydown', this.trappedFocusEvent);
    },

    /**
     * Enlève la contrainte de focus s'il en existe une
     * 
     * @return {void}
     */
    untrapFocus() {
        if (this.trappedFocusEvent) {
            document.removeEventListener('keydown', this.trappedFocusEvent);
            this.trappedFocusEvent = null;
        }

        this.$focusableEls = [];
        this.focusIndex = 0;
    },
};

export default FocusManager;
